export default __webpack_public_path__ + "static/media/workouttimes_5.bfd9df3e.jpg";